import React, { useCallback } from "react"
import { IconXmarkOutline18 as XIcon } from "nucleo-ui-outline-18"

import { IconButton, Loader } from "@productlane/ui"

import type { CustomBodyParams, SlashCommandCustomBodyElement } from "./types"

interface SlashCommandsDialogProps {
	showLoading: boolean
	CustomBody: SlashCommandCustomBodyElement<CustomBodyParams> | undefined
	title: string | null
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onSubmit: (params: any) => void
	onCancel: () => void
	setShowLoading: (loading: boolean) => void
}

export const SlashCommandsDialog: React.FC<SlashCommandsDialogProps> = ({
	showLoading,
	CustomBody,
	title,
	onSubmit,
	onCancel,
	setShowLoading,
}) => {
	const onKeyUpHandler = useCallback(
		(e: React.KeyboardEvent<HTMLDivElement>) => {
			if (e.key === "Escape") {
				onCancel()
			}
		},
		[onCancel],
	)

	return (
		// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
		<div
			role="dialog"
			aria-label="Custom body dialog"
			onKeyUp={onKeyUpHandler}
			className="relative flex w-[22rem] flex-col items-start gap-3 p-4"
		>
			<div className="flex w-full items-center justify-between gap-1 text-sm">
				<h3 className="text-gray-900 dark:text-white">{title ?? ""}</h3>
				<IconButton
					onClick={onCancel}
					variant="ghost"
					size="md"
					Icon={XIcon}
					aria-label="Close"
					className="flex-none"
				/>
			</div>

			{showLoading ? (
				<div className="absolute bottom-0 left-0 right-0 top-0 z-10 flex items-center justify-center bg-white dark:bg-gray-900">
					<Loader />
				</div>
			) : null}
			{CustomBody ? (
				<CustomBody
					submit={onSubmit}
					cancel={onCancel}
					setIsLoading={setShowLoading}
				/>
			) : (
				<div>Failed to load custom body</div>
			)}
		</div>
	)
}
